type NavigateFunction = (to: string) => void;

const NIBSS_BASE = "/products/third-party-apis/nibss/";

const NIBSS_APIS = [
    { label: "Combined Identity Validation", path: "/products/third-party-apis/nibss/combined-identity-validation" },
    { label: "Phone Number Validation", path: "/products/third-party-apis/nibss/phone-number-validation" },
    { label: "Virtual NIN", path: "/products/third-party-apis/nibss/virtual-nin" },
    { label: "TIN Verification", path: "/products/third-party-apis/nibss/tin-verification" },
    { label: "Core Banking Application", path: "/products/third-party-apis/nibss/core-banking-application" },
    { label: "iGree USSD", path: "/products/third-party-apis/nibss/igree-ussd" },
];

export const NibssApiNav = ({ location, navigate }: { location: { pathname: string }; navigate: NavigateFunction }) => {
    if (!location.pathname.startsWith(NIBSS_BASE)) return null;

    return (
        <div className="mb-8 flex items-center border-b overflow-x-auto">
            <span className="text-xs font-semibold text-muted-foreground uppercase tracking-widest whitespace-nowrap pr-4 border-b-2 border-transparent py-2.5">
                NIBSS APIs
            </span>
            {NIBSS_APIS.map(({ label, path }) => {
                const isActive = location.pathname === path;
                return (
                    <button
                        key={path}
                        type="button"
                        onClick={() => navigate(path)}
                        className={`px-4 py-2.5 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors cursor-pointer ${
                            isActive
                                ? "border-primary text-primary font-medium"
                                : "border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground/40"
                        }`}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
};
